export default __webpack_public_path__ + "light-bulb.png";